import "core-js/modules/web.dom.iterable";
//
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { onlineStatistics } from '@/api/api';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '30px'
    },
    position: {
      type: String,
      default: 'absolute'
    },
    left: {
      type: String,
      default: '0px'
    },
    marginLeft: {
      type: String,
      default: '0px'
    },
    id: {}
  },
  watch: {
    id: {
      handler: function handler(val) {
        this.querySewageQuotaList(val);
      },
      immediate: true
    }
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  mounted: function mounted() {
    this.initBarChart(data);
  },
  methods: {
    initBarChart: function initBarChart(data) {
      var option = {
        xAxis: {
          type: 'category',
          data: data.xData,
          axisLabel: {
            color: '#ffffff'
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        series: [{
          data: data.data,
          type: 'bar'
        }]
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      }, false);
    },
    // 趋势数据
    querySewageQuotaList: function querySewageQuotaList(siteId) {
      var _this = this;

      onlineStatistics(siteId).then(function (res) {
        var data = {
          xData: [],
          data: []
        };
        res.forEach(function (v) {
          var time = v.dataTimeStr.length == 2 ? v.dataTimeStr : '' + v.dataTimeStr;
          data.xData.push(time);

          if (v.status == 'true') {
            data.data.push({
              value: 200,
              itemStyle: {
                color: '#00ff00'
              }
            });
          } else {
            data.data.push({
              value: 200,
              itemStyle: {
                color: '#aaaaaa'
              }
            });
          }
        });

        _this.initBarChart(data);
      });
    }
  }
};